// extracted by mini-css-extract-plugin
export default {"expenses":"Expenses_expenses__RpIqU","center":"Expenses_center__2GdB8","whiteFont":"Expenses_whiteFont__YQzFx"};